// extracted by mini-css-extract-plugin
module.exports = {"details":"style_details__3lbeR","time-entry-form":"style_time-entry-form__rIe55","input-container":"style_input-container__2jMva"};